import { Injectable, Optional } from '@angular/core';
import { DataColumn, ColumnFormatter, EnumFormatOptions, ColumnFormatService } from '@farris/ui-common/column';

@Injectable({
    providedIn: 'root'
})
export class CommonUtils {
    private cfs: ColumnFormatService = null;
    constructor() {
        if (!this.cfs) {
            this.cfs = new ColumnFormatService(null, null);
        }
    }

    keyIsInData(field, data) {
        const noProperty = 'no property';
        const val = field.split('.').reduce((obj, key) => {
            if (obj && obj.hasOwnProperty(key)) {
                return obj[key];
            } else {
                return noProperty;
            }
        }, data);

        return val != noProperty;
    }

    /**
     * è·åå¯¹è±¡ä¸­æå®å­æ®µçå¼ã field: å¯ä»¥ä¸ºå¸¦æå±çº§ç»æçè·¯å¾ï¼å¦ï¼ user.firstName | name ç­
     * data: è·åå­æ®µçæ°æ®æºï¼ä¸è¬ä¸ºJSONå¯¹è±¡
     * safe: ä¸ºtrue, å°htmlå­ç¬¦è¿è¡è½¬ç è¾åºï¼é»è®¤ä¸º false
     */
    getValue(field: string, data: any, safe = false) {
        if (!data) {
            return  '';
        }
        let resultVal = '';
        if (field.indexOf('.') === -1 && data.hasOwnProperty(field)) {
            resultVal = data[field];
        } else {
            resultVal = field.split('.').reduce((obj, key) => {
                if (obj) {
                    return obj[key];
                } else {
                    return null;
                }
            }, data);
        }

        if (safe) {
            return this.formatterValue(resultVal);
        } else {
            return resultVal;
        }
    }

    /**
     * æ´æ°æå®å¯¹è±¡ä¸­æä¸ªå­æ®µçå¼
     * @param obj è¢«æ´æ°å¯¹è±¡
     * @param field è¢«æ´æ°å­æ®µ
     * @param val æ°å¼
     * @param nest æ¯å¦ä¸ºåµå¥ï¼é»è®¤ä¸º true
     */
    setValue(obj: { [key: string]: any }, field: string, val: any, nest = true) {
        if (field) {
            if (field.indexOf('.') > -1 && nest) {
                let lastObj = null;
                const _fields = field.split('.');
                _fields.reduce( (c, p) => {
                    lastObj = c;
                    return c[p];
                }, obj);

                if (lastObj) {
                    lastObj[_fields.pop()] = val;
                }
            } else {
                obj[field] = val;
            }
        }
    }

    getEnumItem(value: any, enumData: any[], valueField) {
        const item = enumData.find(n => n[valueField] == value);
        return item;
    }

    private _getEnumTitleFromColumn(value: any, col: any) {
        const _col = col as DataColumn;
        const formatter = _col.formatter as ColumnFormatter;
        if (formatter && typeof formatter === 'object') {
            if (formatter.type === 'enum' && formatter.options) {
                return this.getEnumTitleFromColumnOptions(value, formatter.options);
            }
        }
        return value;
    }

    getEnumTitle(col: DataColumn, data: any ) {
        const val = this.getValue(col.field, data);
        return this._getEnumTitleFromColumn(val, col);
    }

    getEnumTitleFromColumnOptions(value: any, opts: any) {
        const { data, valueField, textField } = opts;
        const item = this.getEnumItem(value, data, valueField);
        if (item) {
            return item[textField];
        } else {
            return value;
        }
    }

    escapeHtml(str) {
        if (str === null || str === undefined) {
            return  '';
        }
        return str
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/\"/g, '&quot;')
        .replace(/\'/g, '&#39;')
        .replace(/\//g, '&#x2F;');
    }

    unescapeHtml(str) {
        if (str === null || str === undefined) {
            return  '';
        }
        return str
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, '\'')
        .replace(/&#x2F;/g, '/');
    }


    private formatterValue(val: any) {
        if (val === null || val === undefined || val === '') {
            return '';
        }

        if (typeof val === 'string') {
            return this.escapeHtml(val);
        }

        return val;
    }

    /** è·åå­ç¬¦ä¸²å¨é¡µé¢ä¸­ççå®å®½åº¦ */
    getTextWidth(txt: string, font) {
        // const frag = document.createDocumentFragment();
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        context.font = font;
        const metrics = context.measureText(txt);
        return Math.round(metrics.width);
    }

    removeStyleSheet(id: string) {
        const styleElement = document.querySelector('#' + id);
        if (styleElement) {
            styleElement.remove();
        }
    }

    createStyleSheet(styleSheetId: string): HTMLStyleElement {
        const htmlHead = document.querySelector('head');

        const styleEleId = styleSheetId;
        let styleElement = null;
        if (document.querySelector('#' + styleEleId)) {
            styleElement = document.querySelector('#' + styleEleId);
            styleElement.innerText = '';
        } else {
            styleElement = document.createElement('style');
            styleElement.id = styleEleId;
            htmlHead.appendChild(styleElement);
        }

        return styleElement;
    }

    getStyleSheet(styleSheetId) {
        const styleSheets = document.styleSheets as any;
        let styleSheet = null;
        for (const stylesheet of styleSheets) {
            if ((stylesheet.ownerNode || stylesheet['owningElement']).id === styleSheetId) {
                styleSheet = stylesheet;
                break;
            }
        }

        return styleSheet;
    }

    /** ä¸ç°ææ ·å¼åå¹¶ */
    appendCssRules(rules: string[], styleSheet) {
        for (const rule of rules) {
            const ruleName = rule.slice(0, rule.indexOf('{'));
            const removedCssRule = this.removeCssRule(ruleName, styleSheet);
            let cssText = '';
            if (removedCssRule) {
                cssText += removedCssRule.cssText.slice(removedCssRule.cssText.indexOf('{') + 1, removedCssRule.cssText.indexOf('}'));
            }
            cssText += rule.slice(rule.indexOf('{') + 1, rule.indexOf('}')).replace(/"/g, '').replace(/,/g, ';') + ';';
            if (styleSheet.addRule) {
                styleSheet.addRule(ruleName, cssText, 0);
            } else {
                const _newRule = `${ruleName}{ ${cssText} }`;
                styleSheet.insertRule(_newRule, 0);
            }
        }
    }

    /** è¦çç°æçæ ·å¼ */
    appendCssRules2(rules: string[], styleSheet) {
        for (const rule of rules) {
            const ruleName = rule.slice(0, rule.indexOf('{'));
            const removedCssRule = this.removeCssRule(ruleName, styleSheet);
            const cssText = rule.slice(rule.indexOf('{') + 1, rule.indexOf('}')).replace(/"/g, '').replace(/,/g, ';') + ';';
            if (styleSheet.addRule) {
                styleSheet.addRule(ruleName, cssText, 0);
            } else {
                const _newRule = `${ruleName}{ ${cssText} }`;
                styleSheet.insertRule(_newRule, 0);
            }
        }
    }

    getCssRule(ruleName: string, styleSheet) {
        const cssRules = (styleSheet.cssRules || styleSheet.rules) as any;
        let r = null;
        for (const rule of cssRules) {
            if (rule.selectorText == ruleName) {
                r = rule;
            }
        }

        return r;
    }

    removeCssRule(ruleName: string, styleSheet ) {
        const cssRules = (styleSheet.cssRules || styleSheet.rules) as any;
        let ii = 0;
        let cssRule: any = false;
        do {
            cssRule = cssRules[ii];
            if (cssRule) {
                if (cssRule.selectorText.toLowerCase() == ruleName.toLowerCase()) {
                    if (styleSheet.cssRules) {
                        styleSheet.deleteRule(ii);
                    } else {
                        styleSheet.removeRule(ii);
                    }

                    return cssRule;
                }
            }
            ii++;
        } while (cssRule);
    }

    isNullOrUndefined(val: any) {
        return val === null || val === undefined;
    }

    isIE() {
        const uA = window.navigator.userAgent;
        return /msie\s|trident\/|edge\//i.test(uA) && !!('uniqueID' in document || 'documentMode' in document || ('ActiveXObject' in window) || 'MSInputMethodContext' in window);
    }

    buildSortString(sorts: any[]): string {
        return this.cfs.buildSortString(sorts);
    }

    buildSqlWhere(conditions: any[]): string {
        return this.cfs.buildSqlWhere(conditions);
    }

    getBrowserType() {
        const ua = navigator.userAgent.toLowerCase();  // è·åç¨æ·ç«¯ä¿¡æ¯
        const info = {
            ie : /msie/ .test(ua) && !/opera/ .test(ua),  //  å¹éIEæµè§å¨
            op : /opera/ .test(ua),  //  å¹éOperaæµè§å¨
            sa : /version.*safari/.test(ua),  // å¹éSafariæµè§å¨
            ch : /chrome/.test(ua),  //  å¹éChromeæµè§å¨
            ff : /gecko/.test(ua) && !/webkit/.test(ua)  // å¹éFirefoxæµè§å¨
        };

        return info;
    }


    getFFVer() {
        const ua = navigator.userAgent;
        const b = ua.indexOf('Firefox/');
        if (b < 0) {
            return 0;
        }
        return parseFloat (ua.substring(b + 8, ua.lastIndexOf('\.')));
    }

    getQueryString(name, locationSearch = '') {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        let _search = window.location.search;
        if (locationSearch) {
            _search = locationSearch;
        }
        var r = _search.substring(1).match(reg);
        if (r != null) return (r[2]); return null;
    }

    /**
     * è·åé¡µé¢ä¸­bodyä¸ææåç´ çzIndex, å¹¶è¿åä¸ä¸ªæµ®å±çæ°zindex
     */
    getFloatingLayerIndex(upperLayers = 1) {

        const selectors = [
            'body>.f-datagrid-settings-simple-host',
            'body>div', 
            'body>farris-dialog>.farris-modal.show',
            'body>.farris-modal.show', 
            'body>farris-filter-panel>.f-filter-panel-wrapper', 
            'body .f-sidebar-show>.f-sidebar-main',
            'body>.popover.show',
            'body>filter-row-panel>.f-datagrid-filter-panel',
            'body>.f-section-maximize'
        ];

        const overlays = Array.from(document.body.querySelectorAll(selectors.join(','))).filter(n => n).map(n => {
            const { display, zIndex } = window.getComputedStyle(n);
            if (display === 'none') {
                return 0;
            }
            return parseInt(zIndex, 10);
        }).filter(n => n);
        let maxZindex = Math.max(...overlays);
        if (maxZindex < 1040) {
            maxZindex = 1040;
        }
        return maxZindex + upperLayers;
    }

    /** ç¹å»Næ¬¡åï¼æ§è¡callback; é»è®¤ç¹å»10æ¬¡åæ§è¡ */
    clickContinuity(callback: () => void,clickTatgatNum = 10) {

        if (this['clickCountNow'] === undefined) {
            this['clickCountNow'] = 0;
        }

        // è¿ç»­ç¹å»æ¬¡æ°å°äºæå®æ¬¡æ°æ¶
        if (this['clickCountNow'] < clickTatgatNum - 1) {
            // æ¸é¤å®æ¶å¨
            if (this['clickTimer']) {
                clearTimeout(this['clickTimer']);
                this['clickTimer'] = null;
            }
            // ç¹å»æ¬¡æ°+1
            this['clickCountNow']++;
            // æå°æ¬¡æ°æ¥å¿
            // console.log(`clickCountNow`, this['clickCountNow'])
            // è®¾ç½®å®æ¶å¨ï¼å¤§äº300æ¯«ç§ç¹å»ä¸ç®è¿ç»­ç¹å»
            this['clickTimer'] = setTimeout(() => {
                this['clickCountNow'] = 0;
            }, 300)
        } else {
            // ç¹å»æ¬¡æ°+1ï¼æ­¤æ¶å·²å¤§äºç­äºæå®ç¹å»æ¬¡æ°ï¼
            this['clickCountNow']++;
            // æå°æ¥å¿
            // console.log(`è¿ç»­ç¹å»äº${this['clickCountNow']}æ¬¡`, `åç¹ä»ä¹`)

            if (callback) {
                callback();
            }

            // æ¸é¤å®æ¶å¨
            if (this['clickTimer']) {
                clearTimeout(this['clickTimer']);
                this['clickTimer'] = null;
            }
            // ç¹å»æ¬¡æ°å½é¶ï¼éæ°è®¡æ°
            this['clickCountNow'] = 0;
    
        }
    }
    
    regBodyKeydownEvent(enterFn?: () => void, escFn?: () => void) {
        const keydownHandle = ($event: KeyboardEvent) => {
            if ($event.key !== 'Escape' && $event.key !== 'Enter') {
                return;
            }
            $event.preventDefault();
            $event.stopPropagation();

            if ($event.key == 'Enter' && enterFn) {
                // æ§è¡æ¥è¯¢
                enterFn();
            } else {
                escFn && escFn();
            }
        }
        document.body.addEventListener('keydown', keydownHandle , true);
        return () => {
            document.body.removeEventListener('keydown', keydownHandle, true);
        }
    }
}
